import React, { Component } from 'react';
import {
    getErrMsg,
    cmsGetServices,
    cmsGetSubscriptionOffers,
    cmsGetPromise,
    cmsPostPromise,
    getBaseOrderInfo
} from '../CallMSAPI.js';
import { toast } from 'react-toastify';
import NewOrderForm from './NewOrderForm';
import { showConsoleLogs } from '../CallMSUIHelpers.js';
import PlaceOrder from './PlaceOrder';
import AccountSubscriptionTable from './AccountSubscriptionTable';

import {
    PBX_USER,
    PBX_USER_LICENCE_CODE,
    TRUNK_USER,
    TRUNK_USER_LICENCE_CODE
} from '../LicenceHelpers';

import { connect } from 'react-redux';
import * as actions from '../store/actions/index';

var _ = require('lodash');

class AccountSubscriptions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offers: null,
            commercialSubs: [],
            openModal: null,
            onlyActive: true,
            orderInProgress: false,
            tableUpdateTime: new Date().getTime(),

            services: [],
            hasActiveService: false,
            hasActiveSFBEnterpriseService: false,
            accountServicesLoaded: false,

            globalCanAction: (
                props.contractAccount.purchasedEnabled === true
                && props.hasRole('PlaceOrders')
            )
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.processSubscriptionUpdate = this.processSubscriptionUpdate.bind(this);
        this.processNewSubscriptionsForm = this.processNewSubscriptionsForm.bind(this);
        this.toggleActiveOnly = this.toggleActiveOnly.bind(this);
        this.fullClose = this.fullClose.bind(this);
        this.updateSubscriptionQuantity = this.updateSubscriptionQuantity.bind(this);
        this.modalCloseNoSave = this.modalCloseNoSave.bind(this);
        this.cancelSubscription = this.cancelSubscription.bind(this);
    }

    showModal(entry) {
        this.setState({
            openModal: entry.Id
        })
    }

    hideModal(entry) {
        this.setState({
            openModal: null,
            orderInProgress: false
        })
    }

    componentDidMount() {
        this.getCommercialSubscriptions();
        this.getOffers();
        this.getServices();
    }

    getOffers() {
        var self = this;
        cmsGetSubscriptionOffers(
            this.props.contractAccount.Id,
            function (offers) {
                self.setState({
                    offers: offers.Results
                });
            }, function (error) {
                if(showConsoleLogs()){
                    console.log("Unable to retrieve any account offers");
                }
                self.setState({
                    offers: []
                });
            }
        );
    }

    getServices() {
        var self = this;
        cmsGetServices(
            self.props.targetAccount.Id,
            function (callmsData) {
                var services = callmsData.Results;
                var hasActiveService = services.length > 0;
                var hasActiveSFBService = false;

                // Look for an SfB enterprise service...
                services.forEach(function(s) {
                    if (s.ServiceCode === 'sfb') {
                        hasActiveSFBService = true;
                    }
                });

                self.setState({
                    services: services,
                    hasActiveService: hasActiveService,
                    hasActiveSFBEnterpriseService: hasActiveSFBService,
                    accountServicesLoaded: true
                });
            },
            function (error) {
                toast.error(error);
            }
        );
    }

    toggleActiveOnly() {
        this.setState(prevState => ({
            onlyActive: !prevState.onlyActive,
            tableUpdateTime: new Date().getTime()
        }), function () {
            this.getCommercialSubscriptions();
        });
    }

    getCommercialSubscriptions() {
        var self = this;
        cmsGetPromise({
            accountId: this.props.contractAccount.Id,
            objectType: 'subscriptions',
            targetAccountId: this.props.targetAccount.Id,
            State: (self.state.onlyActive ? 'Active' : null),
            pageSize: 99999,
        }).then(
            function (data) {
                self.setState({
                    commercialSubs: data.data.Results
                });
            }, function (error) {
                toast.error("Unable to retrieve account subscriptions");
                if(showConsoleLogs()){
                    console.log(error);
                }
            }
        );
    }

    refreshSubscriptions() {
        this.getCommercialSubscriptions();
        this.setState({ tableUpdateTime: new Date().getTime() });
    }

    updateSubscriptionQuantity(entry) {
        entry['NewQuantity'] = parseInt(entry.TempQuantity);

        this.setState({
            commercialSubs: [...this.state.commercialSubs],
            tableUpdateTime: new Date().getTime()
        });

        this.props.setUnsavedChanges && this.props.setUnsavedChanges( this.updatesPending() );
    }

    modalCloseNoSave(entry) {
        delete entry.TempQuantity;
        this.hideModal();
    }

    cancelSubscription(entry) {
        var self = this;

        var msg = "Are you sure you want to cancel the subscription for "
            + entry['_FullOffer'].PlanName + "?";

        if (self.props.targetAccount) {
            var userBlock = null;
            if (entry.PlanCode === PBX_USER) {
                userBlock = _.find(self.props.targetAccount.Licences, { 'ProductCode': PBX_USER_LICENCE_CODE });
            } else if (entry.PlanCode === TRUNK_USER) {
                userBlock = _.find(self.props.targetAccount.Licences, { 'ProductCode': TRUNK_USER_LICENCE_CODE });
            }

            if (userBlock) {
                var remove = entry.Quantity;
                var avail = userBlock['NumPurchased'] - userBlock['NumUsed'];

                if (avail < remove) {
                    var impact = Math.abs(avail - remove);
                    msg += " This will result in " + impact + " active users being unlicenced and unable to make calls.";
                }
            }
        }

        if (window.confirm(msg)) {
            var changes = [{
                "SubscriptionId": entry.Id,
                "State": "Cancelled"
            }];

            var baseOrder = getBaseOrderInfo(self.props.contractAccount.Id, self.props.targetAccount.Id);
            baseOrder["StateChangeItems"] = changes;
            cmsPostPromise(baseOrder).then(function (ok) {
                toast.success("Subscription cancelled");

                // Refresh the data...
                self.refreshSubscriptions();
                self.getOffers();
            }, function (err) {
                toast.error(getErrMsg(err));
            })
        }
    }

    processNewSubscriptionsForm(formik, values, setSubmitting, setErrors, resetForm) {
        var self = this;

        var baseOrder = getBaseOrderInfo(self.props.contractAccount.Id, self.props.targetAccount.Id, values['OrderReference']);
        baseOrder["NewItems"] = values['changes'];

        cmsPostPromise(baseOrder).then(function (ok) {
            toast.success("New order placed");

            // Refresh the data...
            self.refreshSubscriptions();
            self.getOffers();

            setSubmitting && setSubmitting(false);
            resetForm && resetForm();
        }, function (err) {
            setSubmitting && setSubmitting(false);
            toast.error(getErrMsg(err));
        })
    }

    processSubscriptionUpdate(optBaseReference = null) {
        var self = this;

        this.setState({
            orderInProgress: true
        });

        // TODO: Confirm agree to terms and conditions?
        var changes = [];
        this.state.commercialSubs.forEach(function (sub) {
            if (sub.hasOwnProperty('NewQuantity') && sub.NewQuantity !== sub.Quantity) {
                changes.push({
                    "SubscriptionId": sub.Id,
                    "Quantity": sub.NewQuantity,
                })
            }

        });

        var baseOrder = getBaseOrderInfo(self.props.contractAccount.Id, self.props.targetAccount.Id, optBaseReference);
        baseOrder["QuantityChangeItems"] = changes;

        cmsPostPromise(baseOrder).then(function (ok) {
            self.hideModal();
            toast.success("Subscriptions updated");

            // Refresh the data...
            self.refreshSubscriptions();
            self.getOffers();

            // Clear changes so row can be closed
            self.props.clearChanges && self.props.clearChanges();
        }, function (err) {
            self.hideModal();
            toast.error(getErrMsg(err));
            self.props.setUnsavedChanges && self.props.setUnsavedChanges(self.updatesPending());
        })
    }

    updatesPending() {
        var pending = false;
        this.state.commercialSubs.forEach(function (s) {
            if (s.hasOwnProperty('NewQuantity') && s.NewQuantity !== s.Quantity) {
                pending = true;
            }
        })

        return pending;
    }

    fullClose() {
        var self = this;

        if (this.props.clearChanges) {
            this.props.clearChanges(
                function () {
                    self.props.closeCallback && self.props.closeCallback();
                }
            )
        }
    }

    render() {
        var self = this;

        if (this.state.offers === null) {
            return <p>Loading</p>;
        }

        var noUpdate = !this.updatesPending();
        var updateButton = null;
        if (self.state.globalCanAction) {
            updateButton = <button className="btn btn-primary right-action-button" onClick={() => this.showModal({ Id: 'order' })} disabled={noUpdate}>Update Subscriptions</button>;
        }

        var subscriptionTable = (
            <>
                <AccountSubscriptionTable
                    key={`subs-${self.state.onlyActive}`}
                    targetAccount={self.props.targetAccount}
                    onlyActive={self.state.onlyActive}
                    commercialSubs={self.state.commercialSubs}
                    offers={self.state.offers}
                    globalCanAction={self.state.globalCanAction}
                    accountServicesLoaded={self.state.accountServicesLoaded}
                    hasActiveSFBEnterpriseService={self.state.hasActiveSFBEnterpriseService}
                    openModal={self.state.openModal}
                    lastUpdate={self.state.tableUpdateTime}
                    onShowModal={self.showModal}
                    onModalCloseNoSave={self.modalCloseNoSave}
                    onUpdateSubscriptionQuantity={self.updateSubscriptionQuantity}
                    onCancelSubscription={self.cancelSubscription}
                />
                <br/>
                <div className="row">
                    <div className="user-form-action-buttons">
                        {updateButton}
                        <button className="btn right-action-button mb-2 close-form" onClick={this.fullClose}>{this.props.hasUnsavedChanges ? "Cancel" : "Close"}</button>
                    </div>
                </div>
            </>
        );

        var updateModal = (
            <PlaceOrder
                isOpen={self.state.openModal !== null && self.state.openModal === 'order'}
                subs={self.state.commercialSubs}
                orderCallback={(reference) => self.processSubscriptionUpdate(reference)}
                closeCallback={self.hideModal}
                disableOrderButton={self.state.orderInProgress}
            />
        );

        var activeButtonText = 'Viewing Active Only';
        if (!self.state.onlyActive) {
            activeButtonText = 'Viewing All Subscriptions';
        }

        var newOrderForm = null;
        if (this.props.contractAccount.purchasedEnabled === true) {
            newOrderForm = (
                <>
                    {this.state.offers.length ? <hr /> : null}
                    <NewOrderForm
                        submitCallback={this.processNewSubscriptionsForm}
                        submitButtonText="Order Subscriptions"
                        subscriptions={this.state.commercialSubs}
                        allSubscriptions={this.state.commercialSubs}
                        offers={this.state.offers}
                        limitSubscriptions={self.props.limitSubscriptions}
                    />
                </>
            );
        }

        return (
            <>
                <div className="row">
                    <div className="col-md-6">
                        <h4>Subscriptions</h4>
                    </div>
                    <div className="col-md-6 text-right">
                        <button className="btn btn-default" onClick={self.toggleActiveOnly}>{activeButtonText}</button>
                    </div>
                </div>
                {subscriptionTable}
                {updateModal}

                {newOrderForm}
            </>
        );
    }

}
const mapStateToProps = state => {
    const account = state.account;
    return {
        contractAccount: account.contractAccount,
        account: account.account,
        baseAccount: account.baseAccount
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        hasRole: (uiPart = '') => dispatch(actions.hasRole(uiPart))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountSubscriptions);
